"use strict";

exports.__esModule = true;
exports.TooltipGlobals = void 0;
var _styledComponents = require("styled-components");
var _core = require("@blueprintjs/core");
// Changing below will impact all tooltips
var TooltipGlobals = exports.TooltipGlobals = (0, _styledComponents.createGlobalStyle)([".chart-tooltip{.", "{background:", " !important;font-size:12px;padding:10px;}.bp6-popover-arrow-fill{fill:", " !important;}}"], _core.Classes.POPOVER_CONTENT, function (_ref) {
  var theme = _ref.theme;
  return theme.TooltipContentBackgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.TooltipContentBackgroundColor;
});